<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button @click="save" icon="save" bold :text="lang.button_Save" :tooltip="lang.button_Save"
            :disabled="saveButtonStatus" />

          

        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="false" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="false" />

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/LibraryManager/Views/LibraryNew/Middle/Content/Content"
  import * as Tools from '../../../../../Tools/Tools'


export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },
  data () {
    return {

      saveButtonStatus: true,
      backButtonStatus: false,
      saving: false,
      fileCounter: 0,
      fileFeedback: [],
    }
  },
  computed:{
    blockCreateOver2Level() {
      if (this.$store.getters.selectedTreeLibraryItemObject.depth > 2) {
        this.saveButtonStatus = false;
        return true;
      } else {
        this.saveButtonStatus = true;
        return false;
      }
    },
    
  },
  created() {


  },
  watch: {
    blockCreateOver2Level: function () {
      
      
    }
  },
  methods: {
    save(){
      

        let vue = this;
        let trig = false;
        for (let i = 0, lei = this.$store.getters.propertyToSaving.length; i < lei; i++){
          
          
          if ((this.$store.getters.propertyToSaving[i].isRequiredOnRequest == true) && (this.$store.getters.propertyToSaving[i].value == "")) {
            
            trig = true;
            break;
          }
        }
        
        if (trig == true){
          let obj = {
            text: this.lang.alert_error_new_part_required,
            time: 10,
            type: "danger"
          }

          this.$store.dispatch("displayFooterAlert", obj);
        }else{

          let obj = {
            categoryId: this.$store.getters.selectedTreeLibraryItemObject.categoryId,
            values: this.$store.getters.propertyToSaving,
            distributorPartId: ""
          }
          
          
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_createNewLibrary", obj)
          .then(function(result){

            console.log(result)

            if (result.status == "OK"){

              if (result.data != null){

                const goalObj = result.data;

                let revisionId = result.data.revisionId;

                vue.saving = true;

                let obj = {
                  text: vue.lang.alert_success_new_part,
                  time: 10,
                  type: "success"
                }
                vue.$store.dispatch("displayFooterAlert", obj);

                
                if (vue.$store.getters.libraryFilesToSaving.length > 0){

                 
                  vue.fileCounter = 0;

                  vue.importFile(revisionId, goalObj);
                  
                }else{
                  vue.toDetails(goalObj);
                }
                

                

              }else{

                let obj = {
                  text: vue.lang.alert_error_new_part + ".",
                  time: 15,
                  type: "danger"
                }

                vue.$store.dispatch("displayFooterAlert", obj);
              }

              

            }else{
              let obj = {
                text: vue.lang.alert_error_new_part + ": " + result.message,
                time: 15,
                type: "danger"
              }

              vue.$store.dispatch("displayFooterAlert", obj);


            }


          })

          }


    },
    importFile(revisionId, _goalObj){

      this.$store.dispatch("showLoader", {visible: true, text: "push"});
      
      let vue = this;
      let goalObj = _goalObj;
      let lei = vue.$store.getters.libraryFilesToSaving.length;

      const obj = {
        revisionId: revisionId,
        file: vue.$store.getters.libraryFilesToSaving[vue.fileCounter],
        lastModified: Tools.IntegerToIntegerUTC(vue.$store.getters.libraryFilesToSaving[vue.fileCounter].lastModified)
        //lastModified: vue.$store.getters.libraryFilesToSaving[vue.fileCounter].lastModified
      }

      let fileName = vue.$store.getters.libraryFilesToSaving[vue.fileCounter].name;

      vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_importFiles", obj)
      .then(function(result){

        console.log(result)
        let obj2 = {};
        if (result.status == "OK"){
          
          obj2 = {
            result: "Added",
            fileName: fileName,            
            otherLibraries: []
          }
          
        }else{
          
          
          obj2 = {
            result: result.message,
            fileName: fileName,            
            otherLibraries: []
          }
          
          
        }
        vue.fileFeedback.push(obj2);

        vue.fileCounter++;
        
        if (vue.fileCounter > lei - 1) {

          let func = function () {
              vue.fileFeedback = [];
              vue.toDetails(goalObj); 
            }
            

            const dataFiles = {
              fileImportResults: {},
              newRevisionId: null
            }
            for (let i = 0, lei = vue.fileFeedback.length; i < lei; i++){

              const obj = {
                result: vue.fileFeedback[i].result,
                          
                otherLibraries: []
              }
              
              dataFiles.fileImportResults[vue.fileFeedback[i].fileName] = obj;
            }
            vue.$store.dispatch("showLoader", {visible: false, text:""});
            vue.fileFeedback = [];
            const obj = {
              title: vue.lang.modal_title_PushLibrary,
              text: "",
              type: "push_files",
              buttons: 1,
              buttonName: "Close",
              size: "xl",
              lang: vue.lang.modal_PushLibrary,
              funcNo: "",
              funcYes: "",
              funcCustom: func,
              data: dataFiles
            };
            vue.$store.dispatch("showModalComponent", obj);
            
            
          }else{
            
          vue.importFile(revisionId, goalObj);
          }

      })
    },
    toDetails(goalObj){
      this.$store.dispatch("resetPropertyToSaving");

      this.$store.dispatch("deleteAllSelectedRows");

      let to = "/LibraryManager/LibraryDetails";

      const  obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: 1
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: "pendingNew"
            }
            
          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: goalObj.libraryNumber
            }
            
          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: ""
            }
          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: goalObj.libraryType
            }
          }
        }

      this.$store.dispatch("setSelectedRows", [obj]);
      
      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      
      

      

      const query = {
        from: this.$route.path,
        to: to,
        revisionId: goalObj.revisionId,
        id: goalObj.libraryId,
        
      }
      
      this.$router.push({ path: to, query: query });      

    },
    back(){
      

      this.$store.dispatch("resetPropertyToSaving");

      if (this.saving){
        

        const reloadObj = {
            status: true,
            name: "DataTableFilteredOnApiLibComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);

      }

      let to = this.$route.query.from;

      

      
      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query });   
    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryNew/Middle/Middle.vue